module.exports = __webpack_public_path__ + "img/feeds_logo_green.71343f17.png";